import { forwardRef } from "react";
import styled from "@emotion/styled";
import {
  SecondaryButtonProps,
  SecondaryButton as UnlikelySecondaryButton,
} from "@unlikelyai-magic/ui/buttons";

export const ClientSecondaryButton = styled(
  forwardRef<HTMLButtonElement, SecondaryButtonProps>(({ size, ...props }) => (
    <UnlikelySecondaryButton
      {...props}
      onMouseUp={(e) => {
        props.onMouseUp?.(e);
        (e.currentTarget as HTMLButtonElement).blur();
      }}
    />
  ))
)`
  color: ${({ theme }) => theme.colors.action.client.default};
  box-shadow: none !important;
  border: 0.0625rem solid ${({ theme }) => theme.colors.action.client.default};
  background: transparent;
  &:hover,
  &:focus,
  &.ant-btn-loading {
    background: ${({ theme }) => theme.colors.action.client.hover};
    color: ${({ theme }) => theme.colors.text.dark.default};
  }

  &:active {
    background: ${({ theme }) => theme.colors.action.client.clicked};
    color: ${({ theme }) => theme.colors.text.dark.default};
  }

  &:disabled,
  &:disabled:hover {
    color: ${({ theme }) => theme.colors.text.primary.default};
    background: ${({ theme }) => theme.colors.action.client.inactive};
    cursor: not-allowed;
  }
`;
